import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export interface IneltroCredentialsDTO extends z.infer<typeof IneltroCredentialsDTORuntype> {}
export const IneltroCredentialsDTORuntype = z.object({
    client_id: z.string(),
    api_key: z.string(),
});

export interface IneltroCredentialsInputDTO extends z.infer<typeof IneltroCredentialsInputDTORuntype> {}
export const IneltroCredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    api_key: z.string().optional(),
});

export interface IneltroResponseBodyDTO extends z.infer<typeof IneltroResponseBodyDTORuntype> {}
export const IneltroResponseBodyDTORuntype = z.object({
    data: IneltroCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
